import React from "react";
import { smoothScrollHash } from "../lib/smoothScroll";

const STEPS = [
  {
    n: "01",
    title: "Tell us what you need",
    body:
      "Share your Startup stage and goals. Registration only? Full launch bundle? We listen first.",
  },
  {
    n: "02",
    title: "Get a tailored plan",
    body:
      "We map the right entity type, bank, gateway, workspace and digital stack for your business.",
  },
  {
    n: "03",
    title: "We execute, you build",
    body:
      "Paperwork, filings, onboarding, procurement — handled by vetted specialists. You get updates.",
  },
  {
    n: "04",
    title: "Launch & scale",
    body:
      "Go live with compliance, banking, payments and your digital presence — all in weeks, not months.",
  },
];

export default function Process() {
  return (
    <section id="process" className="border-b border-black/10 bg-[#F4F4F5]" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="md:sticky md:top-28">
              <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#EAB308]">
                [ 02 ] Process
              </p>
              <h2 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mt-4">
                Not just fast — right.
              </h2>
              <p className="mt-5 text-black/70 text-base leading-relaxed max-w-md">
                Most founders lose 60–90 days hunting vendors. ZOZO compresses
                that to a single conversation and one accountable team.
              </p>
              <a
                href="#lead-form"
                onClick={smoothScrollHash}
                data-testid="process-cta"
                className="mt-7 inline-flex items-center gap-2 bg-[#EAB308] text-white px-5 py-3 font-semibold hover:bg-black transition-colors"
              >
                Start your journey →
              </a>
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {STEPS.map((s) => (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="border border-black/80 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:neo-shadow-sm"
              >
                <div className="flex items-baseline justify-between">
                  <span className="font-heading font-black text-3xl text-[#EAB308]">
                    {s.n}
                  </span>
                  <span className="text-[10px] tracking-[0.22em] uppercase text-black/50">
                    Step
                  </span>
                </div>
                <h3 className="font-heading font-bold text-xl mt-3">{s.title}</h3>
                <p className="mt-2 text-sm text-black/70 leading-relaxed">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
